.row {
	grid-column: span 12;

	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
	}
}

.col {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.label {
	font-size: 12px;
	font-weight: 600;
	color: var(--color-text-600, #6b7280);
}

.viewerBar {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.buttons {
	display: flex;
	align-items: center;
	gap: 12px;
}

.link {
	font-size: 12px;
	text-decoration: underline;
}

.button {
	font-size: 12px;
	border: none;
	background: transparent;
	text-decoration: underline;
	cursor: pointer;
}

.muted {
	font-size: 12px;
	color: #9ca3af;
}

.viewer {
	margin-top: 8px;
	border: 1px solid var(--color-border, #d1d5db);
	border-radius: 8px;
	overflow: hidden;
	background: #fff;
}

.iframe {
	width: 100%;
	height: 520px;
	border: 0;
}

:global(.react-select__control--is-disabled) {
	background-color: #f9fafb !important;
	border-color: #d1d5db !important;
	cursor: not-allowed;
}

:global(.react-select__multi-value) {
	background-color: #eef2ff;
}

:global(.react-select__multi-value__label) {
	color: #1f2937;
}
